import { useState, useEffect } from 'react';
import TabPanel from './TabPanel';
import { setFocusElement } from '../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getTabOnFocus } from '../../store/global/selectors';
import { getViews } from "../../store/views/selectors";
import DeleteItemAlert from '../molecules/alerts/views/DeleteItemAlert';
import ViewPrompt from '../molecules/dashboardBuilder/ViewPrompt';
import MappingSelector from '../molecules/dashboardBuilder/MappingSelector';
import ViewForm from '../molecules/dashboardBuilder/ViewForm';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';

export default function View({ element }) {

    const dispatch = useDispatch();
    const { setTabConfig, setActiveTab, activeTab } = useBottomDrawer()
    const tabOnFocus = useSelector(getTabOnFocus);
    let selectedView = useSelector(getViews);
    selectedView = element.action == "create" ? null : selectedView;

    const [action, setAction] = useState(null);

    const detailsBC = [
        { label: 'View', url: null }
    ];
    if (selectedView) {
        detailsBC.push({ label: selectedView.name, url: null });
    }


    useEffect(() => {
        setActiveTab(tabOnFocus);
    }, [tabOnFocus])


    const onClose = () => {
        dispatch(setFocusElement({}));
        setAction(null);
    }

    useEffect(() => {
        setTabConfig([
            {
                label: "View"
            },
            {
                label: "Data Source",
                isDisabled: element?.action === "create"
            },
            {
                label: "Prompt",
                isDisabled: element?.action === "create"
            }
        ])
    },[])

    return (
        <>
            {/* <AppBar position="static">
                <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }}>
                    <Tab label="View" />
                    {element.action !== "create" && <Tab label="Data Source"/>} 
                    {element.action !== "create" && <Tab label="Prompt" />}
                </Tabs>
            </AppBar> */}


            <TabPanel value={activeTab} index={0} >
                <ViewForm action={element.action == "create" ? "create" : "edit"} onClose={onClose} selectedView={selectedView}/>

                {action == 'delete_view' &&
                    <DeleteItemAlert onClose={onClose} type={'view'} />
                }

            </TabPanel>

            <TabPanel value={activeTab} index={1} >
                < MappingSelector isView={true}  parentID={""} id={element.id} type={"view"} action={element.action} onClose={onClose} rootId={element.id}/>
            </TabPanel>

            <TabPanel value={activeTab} index={2} >
                <ViewPrompt id={element.id} action={element.action == "create" ? "create" : "edit"} onClose={onClose} />
            </TabPanel>
        </>
    )
}